import React from 'react';
import { withRouter } from 'react-router-dom';
import { Container, Content, FlexboxGrid, Tooltip, Whisper } from 'rsuite';
import IconQuery from '../../../assets/icons/icon_query.svg';
import { useCanAccessDemandForecast } from '../../../hooks/useCanAccessDemandForecast';
import { DEMAND_FORECAST_UPSELL_MESSAGE } from '../../../utils/ipaAccess';

const DEMAND_FORECAST_PATH = '/ipa/ia/simulacoes-analises/previsao-demanda-v2';

const DemandForecastCardContent = () => (
  <div>
    <div>
      <img alt="ícone de previsão" src={IconQuery} />
    </div>
    <div>
      <div>
        <div>
          <h3>Previsão de Demanda</h3>
        </div>
        <div>
          <p>Projete vendas para várias lojas e períodos, testando diferentes estratégias de preços.</p>
        </div>
      </div>
    </div>
  </div>
);

// Sem o adicional PREVISAO_DEMANDA o card continua visivel, mas desabilitado:
// o clique nao navega e o hover explica como contratar.
const DemandForecastCard = ({ history }) => {
  const canAccessDemandForecast = useCanAccessDemandForecast();

  if (!canAccessDemandForecast) {
    return (
      <Whisper trigger="hover" placement="bottom" speaker={<Tooltip>{DEMAND_FORECAST_UPSELL_MESSAGE}</Tooltip>}>
        <Content className="item-card disabled" role="button" aria-disabled="true">
          <DemandForecastCardContent />
        </Content>
      </Whisper>
    );
  }

  return (
    <Content className="item-card" onClick={() => history.push(DEMAND_FORECAST_PATH)}>
      <DemandForecastCardContent />
    </Content>
  );
};

const SimulacoesAnalises = ({ history }) => (
  <Container className="main-container simulacoes-analises-page">
    <FlexboxGrid>
      <FlexboxGrid.Item colspan={24}>
        <Content className="no-margin-bottom page-header">
          <h2>Simulações e Análises</h2>
        </Content>
      </FlexboxGrid.Item>
    </FlexboxGrid>

    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      <div>
        <DemandForecastCard history={history} />
      </div>
    </div>
  </Container>
);

export default withRouter(SimulacoesAnalises);
